import React from 'react';
import { Outlet } from 'react-router-dom';

interface CouncilsRootPageInterface {}

const CouncilsRootPage: React.FC<CouncilsRootPageInterface> = () => <Outlet />;

export default CouncilsRootPage;
